/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface UserStub
 */
export interface UserStub {
  /**
   *
   * @type {string}
   * @memberof UserStub
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof UserStub
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UserStub
   */
  username: string;
  /**
   *
   * @type {boolean}
   * @memberof UserStub
   */
  hasAvatar: boolean;
  /**
   *
   * @type {string}
   * @memberof UserStub
   */
  roleId?: string | null;
}
